import { getCBTExercise } from '../utils/cbtExercises';
import CBTExercise from './CBTExercise';

export default function ResponseCard({ response, mood, stress, onReset }) {
  const cbtExercise = getCBTExercise(mood, stress);

  return (
    <div className="space-y-6 animate-fadeIn">
      {/* Main Response Card */}
      <div className="bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">💬 Your Wellness Insight</h2>

        <div className="space-y-4">
          {/* Empathy Section */}
          <div className="bg-purple-50 border-l-4 border-purple-400 p-4 rounded">
            <p className="text-sm font-semibold text-purple-700 mb-1">💜 We hear you</p>
            <p className="text-gray-700">{response.empathy}</p>
          </div>

          {/* Encouragement Section */}
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded">
            <p className="text-sm font-semibold text-blue-700 mb-1">✨ You've got this</p>
            <p className="text-gray-700">{response.encouragement}</p>
          </div>

          {/* Coping Tip Section */}
          <div className="bg-green-50 border-l-4 border-green-400 p-4 rounded">
            <p className="text-sm font-semibold text-green-700 mb-1">🌱 Try this</p>
            <p className="text-gray-700">{response.coping_tip}</p>
          </div>

          {/* Stress Insight Section */}
          <div className="bg-pink-50 border-l-4 border-pink-400 p-4 rounded">
            <p className="text-sm font-semibold text-pink-700 mb-1">💭 About your stress</p>
            <p className="text-gray-700">{response.stress_insight}</p>
          </div>

          {/* Reflection Question Section */}
          <div className="bg-amber-50 border-l-4 border-amber-400 p-4 rounded">
            <p className="text-sm font-semibold text-amber-700 mb-1">🤔 Something to think about</p>
            <p className="text-gray-700 italic">{response.reflection_question}</p>
          </div>

          {/* Timestamp */}
          <p className="text-xs text-gray-500 text-right pt-2">
            {response.date} at {response.timestamp}
          </p>
        </div>

        <button
          onClick={onReset}
          className="w-full mt-6 bg-gray-200 text-gray-800 font-semibold py-2 rounded-lg hover:bg-gray-300 transition-all"
        >
          Start New Check-In
        </button>
      </div>

      {/* CBT Exercise (if triggered) */}
      {cbtExercise && (
        <CBTExercise exercise={cbtExercise} />
      )}
    </div>
  );
}
